import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { socket } from "../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { parseJWT } from "../utils/jwtUtils";

const Login = () => {
  const [formData, setFormData] = useState({ phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    socket.emit("login", {
      phone: formData.phone.trim(),
      password: formData.password.trim(),
    });

    socket.once("loginResponse", (data) => {
      setLoading(false);

      if (data.success) {
        const userInfo = parseJWT(data?.token);

        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            token: data.token,
          }),
        );

        toast.success("Successfully logged in!");

        setTimeout(() => {
          if (userInfo.role === "admin" || userInfo.role === "super_admin") {
            navigate("/admin-page");
          } else {
            navigate("/");
          }
        }, 1000);
      } else {
        toast.error(data.message || "Login failed!");
      }
    });
  };

  return (
    <section className="relative py-12 bg-gray-900 sm:py-16 lg:py-20 min-h-screen flex items-center">
      <div className="absolute inset-0 overflow-hidden">
        <img
          className="object-cover object-bottom w-full h-full transform rotate-180 opacity-10"
          src="https://cdn.rareblocks.xyz/collection/clarity/images/features/6/background-pattern.png"
          alt=""
        />
      </div>

      <div className="relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 w-full">
        <div className="relative max-w-md mx-auto mt-10 lg:max-w-xl">
          <div className="absolute inset-x-1.5 top-8 -inset-y-4">
            <div
              className="w-full h-full mx-auto rotate-180 rounded-3xl opacity-90 blur-xl filter"
              style={{
                background:
                  "linear-gradient(90deg,#44ff9a -0.55%,#44b0ff 22.86%,#8b44ff 48.36%,#ff6644 73.33%,#ebff70 99.34%)",
              }}
            ></div>
          </div>

          {/* CARD */}
          <div className="relative overflow-hidden rounded-2xl lg:rounded-3xl bg-[#12385d] text-white">
            <div className="px-6 py-7 sm:px-12 sm:py-6">
              <div className="text-center">
                <h1 className="text-3xl font-bold sm:text-4xl xl:text-5xl">
                  Enat Games
                </h1>

                <p className="mt-2 text-lg text-gray-300">
                  ለቴሌ ሲም 09... ለሳፋሪ 07... ይጠቀሙ
                </p>
              </div>

              {/* LOGIN FORM */}
              <form onSubmit={handleLogin} className="mt-6 space-y-4">
                <div>
                  <label className="text-base font-medium text-gray-200">
                    Phone Number
                  </label>

                  <div className="mt-2.5">
                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="09xxxxxxxx"
                      className="block w-full px-4 py-4 text-white placeholder-gray-400 bg-[#0d3558] border border-blue-400/20 rounded-xl focus:border-blue-400 focus:ring-blue-400"
                      required
                    />
                  </div>
                </div>

                <div>
                  <div className="flex items-center justify-between">
                    <label className="text-base font-medium text-gray-200">
                      Password
                    </label>

                    <a
                      href="https://t.me/EnatGamesBot"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-base font-medium text-blue-300 hover:text-blue-400 hover:underline"
                    >
                      Forgot Password?
                    </a>
                  </div>

                  <div className="mt-2.5 relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="********"
                      className="block w-full px-4 py-4 text-white placeholder-gray-400 bg-[#0d3558] border border-blue-400/20 rounded-xl focus:border-blue-400 focus:ring-blue-400"
                      required
                    />

                    <span
                      onClick={togglePasswordVisibility}
                      className="absolute right-4 top-4 cursor-pointer text-black"
                    >
                      {showPassword ? "Hide" : "Show"}
                    </span>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className={`flex items-center justify-center w-full px-8 py-4 text-base font-bold transition-all duration-200 rounded-xl ${
                    loading
                      ? "bg-gray-500 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  }`}
                >
                  {loading ? "Login..." : "Log in"}
                </button>
              </form>

              <p className="mt-8 text-base text-center text-gray-300">
                Don’t have an account?{" "}
                <span
                  onClick={() => navigate("/signup")}
                  className="font-bold cursor-pointer hover:underline text-blue-400"
                >
                  Sign Up
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </section>
  );
};

export default Login;
